import { connect } from '@cerebral/react'
import { sequences, state } from 'cerebral'
import { useEffect } from 'react'
import brand from '../../../lib/util/brand'

const isQuiltt = brand.name === 'Quiltt'

interface MetricsSetupProps {
  analyticsLive?: { _id?: string; resort?: string }
  currentUser?: { _id?: string }
  organization?: { _id?: string }
  find: () => void
}

const MetricSetup = connect(
  {
    analyticsLive: state`analyticsLive.list.data.0`,
    currentUser: state`account.currentUser`,
    organization: state`account.organization`,
    find: sequences`analyticsLive.findForList`,
  },
  ({ analyticsLive, currentUser, organization, find }: MetricsSetupProps) => {
    useEffect(() => {
      if (isQuiltt && currentUser && (!analyticsLive?._id || organization?._id !== analyticsLive?.resort)) {
        find()
      }
    }, [analyticsLive?._id, currentUser?._id])

    return null
  }
)

export default MetricSetup
